import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const activityAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Activity>>('/api/info/sale_activities', { params }).then(({ data }) => data),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/sale_activities/${id}`).then(({ data }) => data),
  create: (data: SaleActivitiesFormPayload) =>
    http.post<SaleActivitiesFormPayload>(`/api/add/sale_activities`, { data }),
  detail: (id: number | string | null) =>
    http.get<DataResponse<Activity>>(`/api/info/sale_activities/${id}`).then(({ data }) => data),
  update: (id: number | string | null, data: SaleActivitiesFormPayload) =>
    http.put<unknown>(`/api/edit/sale_activities/${id}`, { data }),
};

export const activityQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetActivities', params] as const,
      queryFn: () => activityAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  detail: (id: number | string | null) =>
    ({
      queryKey: ['GetDetailSaleActivity', id] as const,
      queryFn: () => activityAPI.detail(id),
    }) as const satisfies QueryOptions,
};
